import { Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import {TabbingOrderService} from '../../../services/tabbing-order.service';

import * as interact from 'interactjs/dist/interact.js';

declare var $:any;


@Component({
  selector: 'app-timer',
  templateUrl: './timer.template.html',
  styleUrls: ['./timer.style.scss']
})
export class Timer implements OnDestroy{
    private _isActive:boolean = false;
    @Output("onClose") onClose: EventEmitter<any> = new EventEmitter();
    @Output() bringTimerWidgetOnTop: EventEmitter<any> = new EventEmitter();
    @Output() onPublishTimerEvent: EventEmitter<any> = new EventEmitter();
    @Input() inputConfig:any;
    @Input() 
    set isActive(flag: boolean) {
        this._isActive = flag;
        if(this._isActive){
            this.initializeTimer();
        } else {
            this.overlay = document.getElementById('timer-overlay-container');
            this.overlay.style.display = 'none';
            this.resetTimer(true);
        }
    }
    get isActive(): boolean { 
        return this._isActive;
    }
    overlay:any; //timer overlay container
    timerArray:any = [0,0,0,0]; //showing 2 values each for minutes and seconds
    timerMin:any = '00'; // minutes on timer 2 way binding
    timerSec:any = '00'; // seconds on timer 2 way binding
    currentTimeInSeconds:any = 0; //current total time in seconds
    totalTimeInSeconds:any = 0; //time entered for the first time
    setIntervalSeconds:any = 0; //seconds calculated from total time in seconds
    setIntervalMinutes:any = 0; //minutes calculated from total time in seconds
    timerContainerColor:any = 0; // border color value with reference to time
    timerRunnerId:any = null; //setInterval id
    timerMute:boolean = false; //boolean for volume in timer
    countUpTimerValue:any = '00'; //timer value in count up state
    initialMin:any; //minutes entered on the first time in timer
    initialSec:any; //seconds entered on the first time in timer
    timerAudio:any;
    activeLaunchMode: string;
    activeTimerState: string;
    position = { x: 0, y: 0 };
    timerOverlay: any;
    timerState = {
        RESET: "reset",
        RUNNING: "play",
        PAUSE: "pause",
        OVER: "over"
    };
    //default config
    config = {
        "launch-mode" : "down",
        "auto-play" : false,
        "count-down" : {
            "time" : 0
        }
    };

    // Used to store the initial value of the timer when the timer is started
    timerStartTimestamp: number = 0;

    constructor(
        public tabbingOrderService: TabbingOrderService
    ) {
        this.activeTimerState = this.timerState.RESET;
        this.orientationChangeEventListener = this.orientationChangeEventListener.bind(this);
    }

    ngOnDestroy() {
        window.removeEventListener("orientationchange", this.orientationChangeEventListener);
        var $timerOverlayContainer:any = $('.timer-overlay-container');
        $timerOverlayContainer.off('mouseup');
        $timerOverlayContainer.off('toc-open-event');
        $timerOverlayContainer.off('toc-close-event');
    }
    

    /**
     * Sets focus on a button element with the given ID after a delay of 0 milliseconds.
     *
     * @param eleId - The ID of the button element to focus.
     */
    focusTimerButtons(eleId){
        setTimeout(() => {
            document.getElementById(eleId).focus();
        }, 0);
    }

    initializeTimer() {

        let that = this;
        this.timerOverlay = document.querySelector('.timer-overlay');
        var contentContainer = document.querySelector('.content-container');
        var $timerOverlayContainer:any = $('.timer-overlay-container');

        this.timerOverlay.style.transform = 'none';
        this.position = { x: 0, y: 0 };

        this.bringLatestWidgetToTop();

        // #333 : Selection Deletion feature not working properly with Audio\Video 

        $timerOverlayContainer.off('mouseup');
        $timerOverlayContainer.off('toc-open-event');
        $timerOverlayContainer.off('toc-close-event');

        $timerOverlayContainer.on('mouseup', function(e) {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('mouseup', false, true);
            var imagebookWrapper = document.querySelector('#imgbook_wrapper');
            imagebookWrapper.dispatchEvent(evt);
        });

        $timerOverlayContainer.on('toc-open-event', function(event) {

            const tocWidth = 320;

            let outerContainer:any = document.querySelector('.outer-container');
            let isContentScrollable = Math.abs(outerContainer.offsetWidth - outerContainer.scrollWidth) > 1 ? true : false;

            let timerOverlayBoundingRect = that.timerOverlay.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();


            if(isContentScrollable) {

                if(event.detail.tocPosition == 'left') {
                
                    if(timerOverlayBoundingRect.right > contentContainerBoundingRect.right) {
                        that.position.x -= (timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
                    } else {

                        if(timerOverlayBoundingRect.right + tocWidth/2 > contentContainerBoundingRect.right) {
                            that.position.x += Math.abs(timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
                        } else {
                            that.position.x += tocWidth/2;
                        }

                    }
                    that.timerOverlay.style.transform = "translate("+that.position.x+"px, "+that.position.y+"px)";
                    
                } else if(event.detail.tocPosition == 'right') {
                
                    if(timerOverlayBoundingRect.left < contentContainerBoundingRect.left) {
                        that.position.x += (contentContainerBoundingRect.left - timerOverlayBoundingRect.left);
                    } else {
                        if(timerOverlayBoundingRect.left - tocWidth/2 < contentContainerBoundingRect.left) {
                            that.position.x -= Math.abs(timerOverlayBoundingRect.left - contentContainerBoundingRect.left);
                        } else {
                            that.position.x -= tocWidth/2;
                        }
                    }
                    that.timerOverlay.style.transform = "translate("+that.position.x+"px, "+that.position.y+"px)";
    
                }

            } else {

                if(timerOverlayBoundingRect.right > contentContainerBoundingRect.right) {
                    that.position.x -= (timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
                }else if(timerOverlayBoundingRect.left < contentContainerBoundingRect.left) {
                    that.position.x += (contentContainerBoundingRect.left - timerOverlayBoundingRect.left );
                }
                that.timerOverlay.style.transform = "translate("+that.position.x+"px, "+that.position.y+"px)";
                    
            }


        });

        $timerOverlayContainer.on('toc-close-event', function(event) {
            
            const tocWidth = 320;

            let timerOverlayBoundingRect = that.timerOverlay.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();

            if(event.detail.wasContentScrollable) {

                if(event.detail.lastTocPosition == 'left') {

                    if(timerOverlayBoundingRect.right + tocWidth/2 >= contentContainerBoundingRect.right) {
                        // empty if block
                        // requirements changed
                    } else {
                        that.position.x -= tocWidth/2;
                    }
                    that.timerOverlay.style.transform = "translate("+that.position.x+"px, "+that.position.y+"px)";
                    
                } else if(event.detail.lastTocPosition == 'right') {

                    if(timerOverlayBoundingRect.left - tocWidth/2 <= contentContainerBoundingRect.left) {
                        // empty if block
                        // requirements changed
                    } else {
                        that.position.x += tocWidth/2;
                    }
                    that.timerOverlay.style.transform = "translate("+that.position.x+"px, "+that.position.y+"px)";

                }

            }

        });


        Object.assign(this.config, this.inputConfig);
        this.timerAudio = new Audio();
        this.timerAudio.src = "./././././assets/audio/TimerAudio1.mp3"
        this.timerAudio.load();
        this.activeLaunchMode = this.config["launch-mode"];
        //to set the total number of seconds from config
        this.totalTimeInSeconds = this.config["count-down"]["time"];
        if(this.activeLaunchMode == "down" && this.totalTimeInSeconds > 0) {
            //to set the timerArray for reset from config
            let time = this.setTimeFromTotalSeconds(this.totalTimeInSeconds);
            this.timerMin = this.initialMin = time.min;
            this.timerSec = this.initialSec = time.sec;
            this.timerArray[0] = this.initialMin[0];
            this.timerArray[1] = this.initialMin[1];
            this.timerArray[2] = this.initialSec[0];
            this.timerArray[3] = this.initialSec[1];
            //to auto-play the count-down timer
            if(this.config["auto-play"]) {
                this.startCountDownTimer('play');
            }
        } else if(this.activeLaunchMode == "up") {
            //to auto-play the count-up timer
            if(this.config["auto-play"]) {
                this.startCountUpTimer('play');
            }
        }   
        this.overlay.style.display = 'flex';

        // drag handling        
        interact('.timer-overlay').draggable({
            allowFrom: ".drag",
            listeners: {
                start (event) {
                    that.bringLatestWidgetToTop();
                },
                move (event) {
                    that.position.x += event.dx;
                    that.position.y += event.dy;
                    event.target.style.transform = `translate(${that.position.x}px, ${that.position.y}px)`;
                }
            },
            restrict: {
                restriction: '.content-container',
                elementRect: {top: 0, left: 0, bottom: 1, right: 1}
            },
        });

        window.addEventListener("orientationchange", this.orientationChangeEventListener);

    }

  /**
   * git issue #99 : tabbing inconsistency after time is completed in count down
   * Handles the keydown event for the reset button.
   * tabindex is set to start index on shift+tab and final index on tab.
   * 
   * @param event - The keyboard event triggered by the user.
   * 
   */
    handleResetBtnKeyDn(event) {
        if (event.key == "Tab" && event.shiftKey) {
            this.tabbingOrderService.firsElementOrLastElement(this.tabbingOrderService.timer?.entity, 'first');
        }
        else if (event.key == "Tab") {
            this.tabbingOrderService.firsElementOrLastElement(this.tabbingOrderService.timer?.entity, 'last');
        }
    }
    emptyArray() {
        //to check whether the timer array is empty
        var bool = this.timerArray.every(checkArray);
        function checkArray(val) {
            return val == 0;
        }
        return bool;
    }

    fullArray() {
        //to check whether the timer array is full
        var bool = this.timerArray.every(checkArray);
        function checkArray(val) {
            return val !== 0;
        }
        if(bool) {
            for(let i=0; i<this.timerArray.length; i++) {
                if(this.timerArray[i] !== "0") {
                    return true;
                }
            }
            return false;
        }
    }

    volumeMute() {
        this.timerMute = !this.timerMute;
    }

    setCountType(countType) {
        this.activeLaunchMode = countType;
        this.resetTimer(true);

        this.keepTimerInBounds();

    }

    enterTimerValue(value) {
        // if the array is empty, fill the array with the value entered by the user
        if(!this.fullArray())
            {
            //to fill the timer array with time entered by the user
            this.timerArray.shift();
            this.timerArray.push(value);
        }
        // if the array is full, bring the focus to the clear timer button
        if(this.fullArray()){
            this.focusTimerButtons('clearCountDownTimer');
        }
        
        this.timerMin = this.timerArray[0].toString() + this.timerArray[1].toString();
        this.timerSec = this.timerArray[2].toString() + this.timerArray[3].toString();
        this.initialMin = this.timerMin;
        this.initialSec = this.timerSec;
        this.totalTimeInSeconds = parseInt(this.timerMin)*60 + parseInt(this.timerSec);
    }
    
    setBorderColor(){
        if (this.currentTimeInSeconds > 0.5 * this.totalTimeInSeconds) { 
            this.timerContainerColor = "green";
        } else if (this.currentTimeInSeconds <= 0.5 * this.totalTimeInSeconds && this.currentTimeInSeconds > 0.1 * this.totalTimeInSeconds) { 
            this.timerContainerColor = "orange";
        } else if (this.currentTimeInSeconds <= 0.1 * this.totalTimeInSeconds && this.currentTimeInSeconds > 0) { 
            this.timerContainerColor = "red";                    
        } else if (this.currentTimeInSeconds == 0) { 
            this.timerContainerColor = "red";
        }
    }

    pad(val) {
        var valString = val + "";
        if (valString.length < 2) {
        return "0" + valString;
        } else {
            return valString;
        }
    }

    setTimeFromTotalSeconds(time) {
        //get time in correct format
        let min,sec;
        min = this.pad(Math.floor(time/60));
        sec = this.pad(time%60);
        return {min,sec};
    }

    startCountDownTimer(status) {  //play, pause
        let self = this;
        this.currentTimeInSeconds = parseInt(this.timerMin) * 60 + parseInt(this.timerSec);
        if (!this.config["auto-play"]) {
            let time = this.setTimeFromTotalSeconds(this.currentTimeInSeconds);
            this.timerMin = time.min
            this.timerSec = time.sec
        }
        if (status == 'play') {
            // Note the start time of the timer
            this.timerStartTimestamp = this.timerStartTimestamp || Date.now();

            this.activeTimerState = this.timerState.RUNNING;
            this.setBorderColor();
            this.timerRunnerId = setInterval(() => {
                this.currentTimeInSeconds--;
                this.setIntervalSeconds = this.currentTimeInSeconds % 60;
                this.setIntervalMinutes = Math.floor(this.currentTimeInSeconds / 60);
                if (this.setIntervalMinutes < 10) {
                    this.setIntervalMinutes = '0' + this.setIntervalMinutes;
                }
                if (this.setIntervalSeconds < 10) {
                    this.setIntervalSeconds = '0' + this.setIntervalSeconds;
                }
                this.timerMin = this.setIntervalMinutes;
                this.timerSec = this.setIntervalSeconds;

                this.setBorderColor();
                if (this.currentTimeInSeconds == 0) {
                    if (!self.timerMute && self.timerAudio) {
                        self.timerAudio.currentTime && (self.timerAudio.currentTime = 0);
                        self.timerAudio.play && self.timerAudio.play();
                    }
                    self.activeTimerState = self.timerState.OVER;
                    clearInterval(self.timerRunnerId);
                    self.timerRunnerId = null;
                    // git issue #99 : tabbing inconsistency after time is completed in count down
                    // focus the reset button to maintain the tabbing behaviour
                    this.focusTimerButtons('resetCountDownTimer');
                }
            }, 1000);
            // git issue #97 : tabbing inconsistency while play/pause of timer in eReader
            // focus the pause button when the timer is played
            this.focusTimerButtons('pauseCountDownTimer');
        } else if (status == 'pause') {
            this.activeTimerState = this.timerState.PAUSE;
            clearInterval(this.timerRunnerId);
            this.timerRunnerId = null;
            // git issue #97 : tabbing inconsistency while play/pause of timer in eReader
            // focus the play button when the timer is paused
            this.focusTimerButtons('playCountDownTimer');
        }
    }

    startCountUpTimer(status) {
        if (status == 'play') {
            // Note the start time of the timer 
            this.timerStartTimestamp = this.timerStartTimestamp || Date.now();

            this.activeTimerState = this.timerState.RUNNING;
            this.timerRunnerId = setInterval(() => {
                ++this.countUpTimerValue;
                this.setIntervalSeconds = this.pad(this.countUpTimerValue % 60);
                this.setIntervalMinutes = this.pad(Math.floor(this.countUpTimerValue / 60));
                this.timerMin = this.setIntervalMinutes;
                this.timerSec = this.setIntervalSeconds;
            }, 1000);
            // git issue #97 : tabbing inconsistency while play/pause of timer in eReader
            // focus the pause button when the timer is played
            this.focusTimerButtons('pauseCountUpTimer');
            
        } else if (status == 'pause') {
            this.activeTimerState = this.timerState.PAUSE;
            clearInterval(this.timerRunnerId);
            this.timerRunnerId = null;
            // git issue #97 : tabbing inconsistency while play/pause of timer in eReader
            // focus the play button when the timer is paused
            this.focusTimerButtons('playCountUpTimer');
        }
    }

    resetTimer(hardReset?) {
        // Publish the timer event if the timer is running
        if (this.timerStartTimestamp) {
            this._calculateTimeSpentAndPublishTimerEvent();
        }

        // Reset the timer
        clearInterval(this.timerRunnerId);
        if (hardReset || this.activeLaunchMode == 'up') {
            this.timerArray = [0, 0, 0, 0];
            this.timerMin = '00';
            this.timerSec = '00';
        } else {
            this.timerMin = this.initialMin;
            this.timerSec = this.initialSec;
        }
        this.timerContainerColor = 0;
        this.countUpTimerValue = '00';
        this.activeTimerState = this.timerState.RESET;
        if (this.timerAudio && this.timerAudio.pause && this.timerAudio.pause()) {
            this.timerAudio.pause();
        }
        if(this.activeLaunchMode == 'up'){
            this.focusTimerButtons('playCountUpTimer');
        }
        else if(this.activeLaunchMode == 'down' && !hardReset){
            this.focusTimerButtons('playCountDownTimer');
        }
        else if(this.activeLaunchMode == 'down' && hardReset){
            this.focusTimerButtons('countDownOne');
        }
        this.keepTimerInBounds();

    }

    /**
     * Closes the timer and emits the onClose event.
     * If the timer is running, it calculates the time spent and publishes the timer event.
     */
    closeTimer() {
        this.onClose.emit()

        // Publish the timer event if the timer is running
        if (this.timerStartTimestamp) {
            this._calculateTimeSpentAndPublishTimerEvent();
        }

        // To handle the focus when the timer is closed
        this.tabbingOrderService.flattenedTabOrderMap.timer2CrossBtn.onClose(this.tabbingOrderService.flattenedTabOrderMap['timer2CrossBtn'], {firstVisibleParent: true});
    }

    /**
     * Calculates the time spent since the timer started and publishes a timer event.
     * 
     * This method computes the elapsed time by subtracting the start timestamp from the current time.
     * It then emits an event with the type of the active launch mode and the calculated time spent.
     * 
     * @private
     */
    _calculateTimeSpentAndPublishTimerEvent() {
        const currentTime = Date.now();
        const timeSpent = currentTime - this.timerStartTimestamp;

        // Publish the timer event
        this.onPublishTimerEvent.emit({ type: this.activeLaunchMode, timeSpent });
        this.timerStartTimestamp = 0;
    }

    bringLatestWidgetToTop() {
        this.bringTimerWidgetOnTop.emit();
    }

    keepTimerInBounds() {
        // NEMO-4870 : [eReader] Audio player is not fully visible when changing player size while positioned at the edge of the screen
        let that = this;
        setTimeout(function () {
            this.timerOverlay = document.querySelector('.timer-overlay');
            let contentContainer: any = document.querySelector('.content-container');
            if (this.timerOverlay.style.transform && this.timerOverlay.getBoundingClientRect().top < 0) {
                //that.position.x = that.position.x;
                that.position.y = that.position.y - this.timerOverlay.getBoundingClientRect().top;
                this.timerOverlay.style.transform = "translate(" + that.position.x + "px, " + that.position.y + "px)";
            } else if (this.timerOverlay.style.transform && this.timerOverlay.getBoundingClientRect().top + this.timerOverlay.getBoundingClientRect().height > contentContainer.getBoundingClientRect().height) {
                //that.position.x = that.position.x;
                that.position.y = that.position.y - (this.timerOverlay.getBoundingClientRect().top + this.timerOverlay.getBoundingClientRect().height - contentContainer.getBoundingClientRect().height);
                this.timerOverlay.style.transform = "translate(" + that.position.x + "px, " + that.position.y + "px)";
            }
        });
    }

    orientationChangeEventListener() {
        this.position.x = 0;
        this.position.y = 0;
        this.timerOverlay.style.transform = "translate("+this.position.x+"px, "+this.position.y+"px)";
    }

}